import chartBarIcon from "../../static/menu_icon/chartBar.svg";
import chartBarFilledIcon from "../../static/menu_icon/chartBarFilled.svg";
import fileExportIcon from "../../static/menu_icon/fileExport.svg";
import fileExportFilledIcon from "../../static/menu_icon/fileExportFilled.svg";
import userIcon from "../../static/menu_icon/user.svg";
import homeIcon from "../../static/menu_icon/home.svg";
import homeFilledIcon from "../../static/menu_icon/homeFilled.svg";
import suitcaseIcon from "../../static/menu_icon/suitcase.svg";
import suitcaseFilledIcon from "../../static/menu_icon/suitcaseFilled.svg";
import usersIcon from "../../static/menu_icon/users.svg";
import usersFilledIcon from "../../static/menu_icon/usersFilled.svg";
import newApplicationsFilledIcon from "../../static/menu_icon/newApplicationsFilled.svg";
import trackingIcon from "../../static/menu_icon/candidateTracking.svg";
import trackingFilledIcon from "../../static/menu_icon/candidateTrackingFilled.svg";
import newFeaturesIcon from "../../static/menu_icon/newFeatures.svg";
import newFeaturesFilledIcon from "../../static/menu_icon/newFeaturesFilled.svg";
import {
  PERMISSIONS,
  REPORT_PERMISSIONS,
  MenuItemConfig,
} from "../../utils/routeAuth";

// Yetki tanimlanmayan menuler herkese aciktir (isMenuItemVisible).
// "Ana Sayfa" ve "Yeni Ozellikler" bilincli olarak yetkisiz birakildi;
// ikincisi zaten hidden/disabled.
const menus: MenuItemConfig[] = [
  {
    id: 1,
    label: "Ana Sayfa",
    url: "/",
    icon: homeIcon,
    activeIcon: homeFilledIcon,
    tooltip: "Ana Sayfa",
  },
  {
    id: 7,
    label: "Aday Takip Panosu",
    url: "/candidate-tracking",
    icon: trackingIcon,
    activeIcon: trackingFilledIcon,
    tooltip: "Aday Takip Panosu",
    role: PERMISSIONS.WISER_CANDIDATE_TRACKING,
  },
  {
    id: 2,
    label: "Pozisyonlar",
    url: "/position-list",
    icon: suitcaseIcon,
    activeIcon: suitcaseFilledIcon,
    tooltip: "Pozisyonlar",
    role: PERMISSIONS.PROJECT,
  },
  {
    id: 3,
    label: "Adaylar - AI Arama",
    url: "/personnel-search",
    icon: usersIcon,
    activeIcon: usersFilledIcon,
    disableActiveTypography: true,
    tooltip: "Adaylar - AI Arama",
    role: PERMISSIONS.CANDIDATE,
  },
  {
    id: 4,
    label: "Yeni Başvurular",
    url: "/new-applications",
    icon: userIcon,
    activeIcon: newApplicationsFilledIcon,
    tooltip: "Yeni Başvurular",
    role: PERMISSIONS.WISER_NEW_APPLICATIONS,
  },

  {
    id: 5,
    label: "Aday Aktarma",
    url: "/candidate-transfer",
    icon: fileExportIcon,
    activeIcon: fileExportFilledIcon,
    tooltip: "Aday Aktarma",
    role: PERMISSIONS.WISER_CANDIDATE_TRANSFER,
  },
  {
    id: 6,
    label: "Raporlar",
    url: "/reports",
    icon: chartBarIcon,
    activeIcon: chartBarFilledIcon,
    activeOnSubmenuRoute: true,
    tooltip: "Raporlar",
    roles: REPORT_PERMISSIONS,
    submenu: [
      {
        id: 60,
        label: "Olumsuz Aday Listesi",
        url: "/negative-candidates-list",
        role: PERMISSIONS.REPORT_NEGATIVE_CANDIDATES,
      },
      {
        id: 61,
        label: "Red Nedenleri Listesi",
        url: "/reject-reasons-list",
        role: PERMISSIONS.REPORT_REJECT_REASONS,
      },
      {
        id: 62,
        label: "KVKK Durum Listesi",
        url: "/kvkk-status-list",
        role: PERMISSIONS.REPORT_KVKK_STATUS,
      },
      {
        id: 63,
        label: "İK Yönetim Raporu",
        url: "/hr-management-report",
        role: PERMISSIONS.REPORT_HR_MANAGEMENT,
      },
      {
        id: 64,
        label: "TalentSpot Test Raporu",
        url: "/talentspot-test-report",
        role: PERMISSIONS.REPORT_TALENT_SPOT,
      },
      {
        id: 65,
        label: "Yerleştirme",
        url: "/placement-report",
        role: PERMISSIONS.REPORT_PLACEMENT,
      },
      {
        id: 66,
        label: "Wiser KPI",
        url: "/wiser-kpi",
        role: PERMISSIONS.REPORT_WISER_KPI,
      },
      {
        id: 67,
        label: "Kullanım İstatistikleri",
        url: "/usage-statistics",
        role: PERMISSIONS.REPORT_USAGE_STATISTICS,
      },
    ],
  },
  {
    id: 8,
    label: "Yeni Özellikler",
    url: "/new-features",
    icon: newFeaturesIcon,
    activeIcon: newFeaturesFilledIcon,
    activeOnSubmenuRoute: true,
    tooltip: "Yeni Özellikler",
    hidden: true,
    disabled: true,
    submenu: [
      {
        id: 80,
        label: "Web Başvuru Widget",
        url: "/web-application-widget",
      },
    ],
  },
  {
    id: 9,
    label: "Yönetim",
    url: "/user-management",
    icon: userIcon,
    activeIcon: usersFilledIcon,
    tooltip: "Yönetim",
    role: PERMISSIONS.USER_ADMIN,
    activeOnSubmenuRoute: true,
    submenu: [
      {
        id: 90,
        label: "Kullanıcılar",
        url: "/user-management",
        role: PERMISSIONS.USER_ADMIN,
      },
      {
        id: 91,
        label: "Dış Kaynak Eşleme",
        url: "/external-source-map",
        role: PERMISSIONS.USER_ADMIN,
      },
      {
        id: 92,
        label: "Konfigürasyon",
        url: "/configuration",
        role: PERMISSIONS.CONFIGURATION,
      },
      {
        id: 93,
        label: "Şirket & Müşteriler",
        url: "/companies-customers",
        role: PERMISSIONS.MASTER_DATA_ADMIN,
      },
    ],
  },
];

export default menus;
